import React, { useState } from "react";
import Iframe from "react-iframe";
const Coba4 = () => {
	const [show1, setShow1] = useState(false);
	const [show2, setShow2] = useState(false);
	const [show3, setShow3] = useState(false);
	const [show4, setShow4] = useState(false);
	const [show5, setShow5] = useState(false);
	const [show6, setShow6] = useState(false);

	const [styleno1, setStyleno1] = useState({ width: "50px" });
	const [styleno2, setStyleno2] = useState({ width: "50px" });
	const [styleno3, setStyleno3] = useState({ width: "50px" });
	const [styleno4, setStyleno4] = useState({ width: "50px" });
	const [styleno5, setStyleno5] = useState({ width: "50px" });
	const [styleno6, setStyleno6] = useState({ width: "50px" });

	const handleNo1 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "2") {
			setStyleno1({
				width: "50px",
				border: "6px solid #1aff66",
			});
			setShow1(true);
		} else if (jwb === "") {
			setStyleno1({
				width: "50px",
				border: "6px solid yellow",
			});
		} else {
			setStyleno1({
				width: "50px",
				border: "6px solid red",
			});
		}
	};

	const handleNo2 = (no2) => {
		const jwb = no2.target.value;
		if (jwb === "3") {
			setStyleno2({
				width: "50px",
				border: "6px solid #1aff66",
			});
			setShow2(true);
		} else if (jwb === "") {
			setStyleno2({
				width: "50px",
				border: "6px solid yellow",
			});
		} else {
			setStyleno2({
				width: "50px",
				border: "6px solid red",
			});
		}
	};
	const handleNo3 = (no3) => {
		const jwb = no3.target.value;
		if (jwb === "1") {
			setStyleno3({
				width: "50px",
				border: "6px solid #1aff66",
			});
			setShow3(true);
		} else if (jwb === "") {
			setStyleno3({
				width: "50px",
				border: "6px solid yellow",
			});
		} else {
			setStyleno3({
				width: "50px",
				border: "6px solid red",
			});
		}
	};
	const handleNo4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "2") {
			setStyleno4({
				width: "50px",
				border: "6px solid #1aff66",
			});
			setShow4(true);
		} else if (jwb === "") {
			setStyleno4({
				width: "50px",
				border: "6px solid yellow",
			});
		} else {
			setStyleno4({
				width: "50px",
				border: "6px solid red",
			});
		}
	};
	const handleno5 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "12") {
			setStyleno5({
				width: "50px",
				border: "6px solid #1aff66",
			});
			setShow5(true);
		} else if (jwb === "") {
			setStyleno5({
				width: "50px",
				border: "6px solid yellow",
			});
		} else {
			setStyleno5({
				width: "50px",
				border: "6px solid red",
			});
		}
	};
	const handleno6 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "6") {
			setStyleno6({
				width: "50px",
				border: "6px solid #1aff66",
			});
			setShow6(true);
		} else if (jwb === "") {
			setStyleno6({
				width: "50px",
				border: "6px solid yellow",
			});
		} else {
			setStyleno6({
				width: "50px",
				border: "6px solid red",
			});
		}
	};
	return (
		<div className="container">
			<div className="d-flex justify-content-center">
				<Iframe
					scrolling="no"
					title="Coba4jsmarimencobapart3"
					src="https://www.geogebra.org/material/iframe/id/tag8wwsd/width/700/height/500/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/false/sdz/true/ctl/false"
					width="700px"
					height="500px"
					allowFullScreen
				/>
			</div>
			<p className="text-center alert alert-warning mt-2">
				Coba tentukan pertidaksamaan dari titik koordinat yang berwana{" "}
				<b>MERAH</b>
			</p>
			<div
				className="mt-2"
				style={{
					display: "flex",
					justifyContent: "space-between",
					width: "30%",
					margin: "auto",
				}}
			>
				<h2>
					<input type="text" onChange={handleNo1} style={styleno1} />x
				</h2>
				<h2>-</h2>
				<h2>
					<input type="text" onChange={handleNo2} style={styleno2} />y
				</h2>
				<h2>≤</h2>
				<h2>
					<input type="text" onChange={handleno5} style={styleno5} />
				</h2>
				<h4>(1)</h4>
			</div>
			{show1 && show2 && show5 ? (
				<>
					<p className="text-center alert alert-warning mt-2">
						Coba tentukan pertidaksamaan dari titik koordinat yang berwana{" "}
						<b>BIRU</b>
					</p>
					<div
						className="mt-2"
						style={{
							display: "flex",
							justifyContent: "space-between",
							width: "30%",
							margin: "auto",
						}}
					>
						<h2>
							<input type="text" onChange={handleNo3} style={styleno3} />x
						</h2>
						<h2>+</h2>
						<h2>
							<input type="text" onChange={handleNo4} style={styleno4} />y
						</h2>
						<h2>≤</h2>
						<h2>
							{" "}
							<input type="text" onChange={handleno6} style={styleno6} />
						</h2>
						<h4>(2)</h4>
					</div>
					{show3 && show4 && show6 ? (
						<>
							<div className="text-center alert alert-success h6 mb-2">
								Selamat kamu benar!!
							</div>
							<div className="text-center alert alert-success h4">
								Selanjutnya kamu bisa tutup halaman ini dan kemudian lanjut ke
								kuis ya
							</div>
						</>
					) : null}
				</>
			) : null}
		</div>
	);
};

export default Coba4;
